/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Standard_PriceInputs */

const et_plan_standard_price = /** @type {(inputs: Plan_Standard_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€449 / Kuus`)
};

const en_plan_standard_price = /** @type {(inputs: Plan_Standard_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€449 / Month`)
};

/**
* | output |
* | --- |
* | "€449 / Month" |
*
* @param {Plan_Standard_PriceInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_standard_price = /** @type {((inputs?: Plan_Standard_PriceInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Standard_PriceInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_standard_price(inputs)
	return en_plan_standard_price(inputs)
});